<template>

<app-wrapper v-if="is.loaded">

    <com-head />

    <div v-if="!window.is.mobile && !isReviewing" class="business-actions">

        <app-button v-if="!isSessionBusiness" :to="{name: 'Business/Reviews/Write'}" theme="yellow" :fixed="true" :text="page.about_buttons_review" />
        <app-button :to="{name: 'Business/Bookings'}" theme="blue" :fixed="true" :text="textBookings" v-if="page.business.bookings && !page.business.bookingsURL" />
        <app-button :href="page.business.bookingsURL" target="_blank" theme="blue" :fixed="true" :text="textBookings" v-if="page.business.bookings && page.business.bookingsURL" />

    </div>

    <com-menu v-if="(!window.is.mobile || $route.meta.root) && !isReviewing" />

    <app-wrapper v-if="!window.is.mobile || !$route.meta.root">
        
        <router-view></router-view>

    </app-wrapper>

    <div v-if="window.is.mobile && !isReviewing" class="business-actions">

        <app-button v-if="!isSessionBusiness" :to="{name: 'Business/Reviews/Write'}" theme="yellow" :fixed="true" :text="page.about_buttons_review" />
        <app-button :to="{name: 'Business/Bookings'}" theme="blue" :fixed="true" :text="textBookings" v-if="page.business.bookings && !page.business.bookingsURL" />
        <app-button :href="page.business.bookingsURL" target="_blank" theme="blue" :fixed="true" :text="textBookings" v-if="page.business.bookings && page.business.bookingsURL" />
        <app-button :to="{name: 'Search', query: searchQuery }" theme="blue" :fixed="true" :text="page.about_buttons_back" v-if="search" />

    </div>

</app-wrapper>

</template>

<script>

import mixinPage from '@/mixin/page.js'

import comHead from './business/Head'
import comMenu from './business/Menu'

export default {

    mixins: [mixinPage],

    components: {
        'com-head': comHead,
        'com-menu': comMenu
	},

	data: function() {

		return {
			search: false
		}

	},
	
	created: function() {

		this.search = this.$route.query.search || false

		if (this.search) {

			this.$router.replace({
				name: 'Business'
			})

		}

	},

    computed: {

		searchQuery: function() {

			return JSON.parse(this.search)

		},

        isReviewing: function() {

            return this.$route.name === 'Business/Reviews/Write'

        },

        textBookings: function() {

            return this.$_.findWhere(this.data.tabs, {
                id: this.page.business.tab.bookings
            }).name

        }

    }

}

</script>

<style scoped>

.business-actions {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 40px;
}

.business-actions >>> .button {
    width: 200px;
    margin: 0px 10px;
}

.is-mobile .business-actions {
    flex-direction: column;
    margin: 0px;
	position: fixed;
	bottom: 0px;
	left: 0px;
	width: 100%;
	z-index: 10;
	padding: 10px 0px;
	background-color: #fff;
	border-top: 1px solid var(--color-grey-light);
}

.is-mobile .business-actions >>> .button {
    width: calc(100% - 20px);
	margin-top: 4px;
}

.is-mobile .business-actions >>> .button:first-child {
	margin-top: 0px;
}

</style>